import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'
import createResellingService from './ResellingService'
import config from "../config"

const PRODUCT_CODE = 'YEXT_V2'

interface IYextAvailabilityResponse {
  offeringAllowed: boolean
  locationCountry: boolean
  availableCountries: Array<{
    label: string
    value: string
  }>,
  countryPublisherCount: number
}

// Create ResellingService instance using the factory function
const resellingService = createResellingService(config.resellingBaseUrl, PRODUCT_CODE)

// Configure request setup
const serviceName = 'YextResellingService'
const host = servicesConfig.Yext as string
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const YextResellingService = {
  resellingService,
  
  getLocationConfig: (locationId: string) => 
    request().get(`/reselling/location/${locationId}`).then(responseBody),

  getCompanyConfig: (companyId: string) => 
    request().get(`/reselling/company/${companyId}`).then(responseBody),

  updateCompanyResellingConfig: (
    companyId: string,
    data: { amount?: number; saasOfferPlanType?: string; planLevel?: number }
  ) => request().put(`/reselling/company/${companyId}`, data).then(responseBody),

  updateLocationResellingConfig: (locationId: string, data: { amount?: number; offeringEnabled?: boolean }) =>
    request().put(`/reselling/location/${locationId}`, data).then(responseBody),

  createAgencyDirectSubscription: (locationId: string) =>
    request().post(`/reselling/location/${locationId}/purchase/company-direct-purchase`, {}).then(responseBody),

  getLocationSubscriptions: (locationId: string) =>
    request().get(`/reselling/location/${locationId}/subscriptions`).then(responseBody),

  checkYextAvailable: (locationId: string): Promise<IYextAvailabilityResponse> => {
    return request().get(`/available/${locationId}`).then(responseBody)
  },

  getLocationEntities:(locationId: string) => {
    return request().get(`/lc-listings/${locationId}/entities`)
  }
}

export default YextResellingService
